module.exports = __webpack_public_path__ + "img/地图C-小巷主题晚餐.a680e197.png";